import React from 'react';
import './styles/modal.css';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      exiting: false,
    };
  }

  close = () => {
    this.setState({ exiting: true });
    setTimeout(() => {
      this.setState({ exiting: false });
      this.props.onClose();
    }, 300);
  };

  componentDidUpdate() {
    if (!this.props.show) {
      document.body.style.overflow = 'auto';
    } else {
      document.body.style.overflow = 'hidden';
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = 'auto';
  }

  render() {
    const { show } = this.props;
    const { exiting } = this.state;

    return (
      <div className={`modal-overlay ${show ? 'show' : ''} ${exiting ? 'hide' : ''}`} onClick={this.close}>
        <div className="modal-content" onClick={e => e.stopPropagation()}>
          <div className="modal-header">
            <div>
              <h3 className="modal-title">{this.props.title}</h3>
            </div>
            <button className="modal-close" onClick={this.close}>
              &times;
            </button>
          </div>
          <div className="modal-subtitle">{this.props.subtitle}</div>
          <div className="modal-body">{this.props.children}</div>
          <div className="modal-footer">
            <button className="btn" onClick={this.close}>
              Chiudi
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js